import { IReport7ApplicantPresentationModel } from "../../../presenter/report/model/Report7ApplicantPresentationModel";
import { IReport7NumericValuePresentationModel } from "../../../presenter/report/model/Report7NumericValuePresentationModel";

const Report7ApplicantsMapper = (
  applicants: IReport7ApplicantPresentationModel[],
  numericalValues: IReport7NumericValuePresentationModel[]
) => {
  return applicants.map((applicant: IReport7ApplicantPresentationModel) => {
    const applicantNumericValues = numericalValues.filter(
      (numericValues: IReport7NumericValuePresentationModel) =>
        numericValues.applicantId === applicant.id
    );
    applicant.numericValues = applicantNumericValues;
    return applicant;
  });
};
export default Report7ApplicantsMapper;
